import React from 'react';
import { Link } from 'react-router-dom';
import { OCCASIONS } from '../mock';
import Reveal from './Reveal';

export default function Occasions() {
  return (
    <section id="occasions" className="py-20 lg:py-28 bg-[#F1ECE3]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
            <div className="max-w-xl">
              <span className="text-[13px] tracking-[0.3em] uppercase text-[#C4715A] font-medium">Shop by Occasion</span>
              <h2 className="font-serif-display text-[36px] sm:text-[46px] text-[#26302a] mt-3 leading-tight">Flowers for every reason to celebrate</h2>
            </div>
            <p className="text-[16px] text-[#5A554C] max-w-sm">From joyful birthdays to heartfelt sympathies, we have the perfect arrangement for the moment.</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {OCCASIONS.map((o, i) => (
            <Reveal key={o.name} delay={i * 90}>
              <Link to={`/occasions/${o.slug}`} className="group relative block rounded-2xl overflow-hidden aspect-[3/4]">
                <img src={o.img} alt={o.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#26302a]/80 via-[#26302a]/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-serif-display text-white text-[22px] leading-tight">{o.name}</h3>
                  <p className="text-[13px] text-[#E9D4CE] mt-1 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">{o.desc}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
